// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-group {
	overflow-y: auto;
}

.full-width-control {
	width: 100%
}

.vcenter {
	display: inline-block;
	vertical-align: middle;
	float: none;
}

body,
html {
	height: 100%;
}

body {
	overflow: hidden !important;
}

.full-height {
	height: 100%;
}

.switch-container {
	height: 750px;
}

.switch-container>li {
	height: 9%;
}

.switch-container>ul {
	height: 91%;
}

.list-wrapper {
	height: 550px;
	margin-left: 15px;
	margin-right: 15px;
}

.border-padding {
	margin-left: 15px;
	margin-right: 15px;
}

.list-wrapper>.list-container {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.vertical-center {
	margin-bottom: auto;
	margin-top: auto;
}

.spinner-center {
	width: 4rem !important;
	height: 4rem !important;
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 6;
	margin: -2rem 0 0 -2rem;
}

.spinner-wrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 5;
	opacity: 0.5;
	margin: -2rem 0 0 -2rem;
	background-color: #efeeef
}

.modal-dialog>.modal-content {
	overflow: auto;
	resize: horizontal;
}

.move-cursor {
	cursor: move;
}

.no-cursor {
	cursor: auto;
}

.dropdown-scrollable {
	height: 155px;
	min-width: 100%;
	overflow: auto;
}

.dropdown-no-scroll {
	min-width: 100%;
	overflow: auto;
}

.truncated-line {
	text-overflow: ellipsis;
	overflow: hidden;
	width: 160px;
	white-space: nowrap;
}

.label-default {
	font-size: 1em !important;
}

.colorpicker-cover {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
}

.colorpicker-popover {
	position: absolute;
	z-index: 2;
}

.hue-wrapper {
	height: 12px;
	position: relative;
}

.color-item-wrapper {
	box-sizing: border-box;
	width: 10%;
	padding-right: 1px;
	float: left;
}

.color-item {
	height: 12px;
	cursor: pointer;
}

.color-item-active {
	transform: scaleY(1.8);
	border-radius: 3.6px/2px;
}

.color-item-pointer {
	height: 16px;
	width: 16px;
	cursor: pointer;
	box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2)
}

.legend-box {
	height: 16px;
	width: 16px;
	box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2)
}

.color-pointer-active {
	transform: scale(1.4);
	border-radius: 3.6px/2px;
}

.map-tooltip {
	padding: 10px;
	background-color: black;
	color: white;
	position: absolute;
	z-index: 1;
	pointer-events: none;
}

/* Override styles from Site.css */
.sticky-head {
	background: white;
	font-size: 1.0em
}

.table-scrollable {
	/*overflow: auto;*/
	height: 550px;
}

.table-cell-modified {
	background-color: #fcd9c4 !important;
	font-weight: bold;
}

.container-height {
	height: 89vh;
}

.container-height-sm {
	height: 80vh;
}

.map-legend {
	padding: 10px 10px 10px 3px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	line-height: 18px;
	margin-bottom: 40px;
}

.map-overlay {
	position: absolute;
	bottom: 0;
	right: 0;
	background: rgba(255, 255, 255, 0.8);
	margin-right: 20px;
	overflow: auto;
	border-radius: 3px;
}

.dropdown-top {
	z-index: 9999 !important;
}

.cursor-pointer {
	cursor: pointer;
}

.reporting-container-padding {
	padding-left: 0 !important;
}

.no-margin {
	margin: 0 !important;
}

.sticky-bottom {
	position: -webkit-sticky;
	position: sticky;
	bottom: 0;
}

.sticky-top {
	position: sticky;
	top: 0;
	z-index: 4;
	border: 0px !important;
}

.simplebar-scrollbar::before {
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	transition: background-color .2s linear, width .2s ease-in-out;
	position: absolute;
}

.overflow-visible {
	overflow: visible !important;
}

.li-dark {
	color: #fff;
	background-color: #3b3e66;
}

.pagination-wrapper {
	position: absolute;
	transform: translateX(-50%);
	left: 50%
}

.dropdown-menu-sm {
	min-width: 6rem;
}

.pe-none {
	pointer-events: none
}

.w-5 {
	width: 5%;
}

.ra-item {
	padding: 12px;
}

.ra-item.active,
.ra-item:hover {
	background-color: #f4f5fc;
}

.dropdown-full-width>.truncated-line {
	width: 100%;
}

.dropdown-with-icon>button::before {
	position: relative;
	top: 2px;
	right: 4px;
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: "";
	border-top: 0.3em solid;
	border-right: 0.3em solid transparent;
	border-bottom: 0;
	border-left: 0.3em solid transparent;
}


.lable-as-NavLink {
	color: #7a7b97;
	display: flex;
	padding: 8px 16px;
	margin: 1px 0;
	border-radius: 0.29rem;
	cursor: pointer;
}

.lable-as-NavLink:hover {
	background: rgba(122, 123, 151, 0.05);
}

/* Dashboard Mgmt tree view styles */
.nested {
	position: relative;
}

.nested::before {
	content: "";
	position: absolute;
	top: -12px;
	left: 5px;
	width: 1.5rem;
	height: 100%;
	border-left: 1px solid #D7D7DF;
}

.nested::after {
	content: "";
	position: absolute;
	top: -12px;
	left: 5px;
	width: 10px;
	height: 100%;
	border-bottom: 1px solid #D7D7DF;
}

.nested span {
	position: relative;
}

.nested span::before {
	content: "";
	position: absolute;
	top: -5px;
	left: -11px;
	width: 10px;
	height: 16px;
	border-bottom: 1px solid #D7D7DF;
}

/* StaticReport page. */
.static-reports-wrapper .nav-justified .nav-item {
	flex-grow: 0 !important;
	min-width: 150px !important;
}

.static-reports-wrapper .container-height .tab-pane {
	height: calc(100% - 50px);
}

.cases-block .card {
	box-shadow: none !important;
	border: none !important;
	border-radius: 0 !important;
}

.cases-block .card .card-header {
	border-radius: 0 !important;
}

.cases-block .card-header {
	border-radius: 0 !important;
}

.accordion-chevron {
	transition: transform 0.3s ease-in-out;
}

.disabled-action-item {
	pointer-events: none;
	opacity: 0.6;
}

.static-reports-editor-tab-container {
	border: 1px solid rgba(122, 123, 151, 0.3);
	max-width: 100%;
}

.static-reports-editor-tab-accordion-container {
	border-right: 1px solid rgba(122, 123, 151, 0.3);
	padding: 0;
	max-width: 300px;
	min-width: 300px;
}

.static-reports-editor-tab-scenarios-container {
	position: 'relative';
	border-left: 1px solid rgba(122, 123, 151, 0.3);
	max-width: 400px;
	min-width: 400px;
}

.static-reports-editor-tab-img-container {
	border-radius: 50%;
	background-color: #ededed;
	width: 100px;
	height: 100px;
}

.static-reports-editor-tab-btn-group-container {
	height: 50px;
	border-top: 1px solid rgba(122, 123, 151, 0.3);
	border-bottom: 1px solid rgba(122, 123, 151, 0.3);
	position: relative;
}

.static-reports-editor-tab-toggle-btn-container {
	width: fit-content;
	position: absolute;
	right: 0;
	top: 1px;
	z-index: 99;
	border: 1px solid #D7D7DF;
}

.static-reports-toggle-result-btn-container {
	width: fit-content;
	position: absolute;
	right: 50%;
	bottom: 0;
	z-index: 99;
	border: 1px solid #D7D7DF;
	border-bottom: 0;
}

.static-reports-border-bottom {
	border-bottom: 1px solid rgba(122, 123, 151, 0.3);
}

.static-reports-border-top {
	border-top: 1px solid rgba(122, 123, 151, 0.3);
}

.static-reports-edit-modal-warning {
	display: block;
	min-height: 42px;
	margin-top: 7px;
}

.static-reports-edit-modal-editor-wrapper {
	resize: vertical;
	overflow: hidden;
	min-height: 200px;
	max-height: 500px;
	border: 1px solid #d1d2db;
	border-radius: 0.29rem;
}

.saved-reports-tree-view-container {
	overflow-y: auto;
	overflow-x: hidden;
	height: calc(100% - 100px);
}

.static-reports-history-sidebar {
	position: absolute;
	top: 0;
	right: 0;
	width: 300px;
	height: 100%;
	background-color: #fff;
	z-index: 1000;
	border: 1px solid #D7D7DF;
	box-shadow: -7px 0px 7px 0px #00000012;
}

.static-reports-history-sidebar-header {
	border-bottom: 1px solid #D7D7DF;
	background-color: #f4f5fd;
}

.static-reports-history-sidebar-scenario {
	border-bottom: 1px solid rgba(7, 9, 25, 0.125);
	padding: 10px 16px;
	display: flex;
	gap: 10px;
}

.static-reports-history-sidebar-scenario b {
	width: 210px;
}

/* Task 3589 on-hold */
.static-reports-container-csv-file {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: fit-content;
	padding: 16px 40px;
	border: 1px dashed gray;
	border-radius: 10px;
}

.static-reports-container-delete-btn {
	position: absolute;
	top: 5px;
	right: 8px;
	cursor: pointer;
	transition: color 0.3s ease;
}

.static-reports-container-delete-btn:hover {
	color: red;
}

/*  */

/* Dashboard Viewer */
.dashboard-viewer .cases-block-viewer .card {
	height: 100% !important;
	margin: 0 !important;
}

.dashboard-viewer .cases-block-viewer .scrollbar-container {
	height: 100% !important;
}

.dashboard-viewer .crt-group-btn {
	font-size: 14px;
	border: 1px solid #3B3E66;
	border-radius: 8px;
	padding: 4px 8px;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.dashboard-viewer .crt-group-btn:hover {
	background-color: #676EF7 !important;
	color: #fff;
}

.dashboard-viewer .border-light {
	border: 1px solid #D7D7DF !important;
}

.dashboard-viewer .cases-sidebar {
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 999;
	max-width: 450px;
	height: calc(100% - 95px);
	margin: 12px 0;
}

.dashboard-viewer .cases-sidebar .hide-arrow {
	top: 50%;
	transform: translateY(-50%);
	left: -37px;
}

.dashboard-viewer .show-arrow {
	top: 50%;
	right: 0;
	transform: translateY(-50%);
}

.dashboard-viewer .show-arrow-viewer {
	border-top-left-radius: 0.65rem;
	border-bottom-right-radius: 0.65rem;
}

.dashboard-viewer .arrows {
	position: absolute;
	z-index: 999;
	cursor: pointer;
	padding: 8px;
}

.dashboard-viewer .group-wrapper {
	border-radius: 0 !important;
	box-shadow: none;
}

/* CommonCaseStatusIndicator */
.status-indicator-container {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 15px;
}

.status-indicator {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	font-size: 1rem;
	font-weight: bold;
	color: white;
	position: relative;
	z-index: 2;
	border: 5px solid transparent;
}

.status-indicator.green {
	/* Bootstrap Success color*/
	background: #1bc943;
}

.status-indicator.red {
	/* Bootstrap Danger color*/
	background: #dc3545;
}

.status-indicator.blue {
	background: #4191ff;
}

.status-indicator.grey {
	/* Bootstrap Secondary color*/
	background: #6c757d;
}

.status-indicator.orange {
	/* Bootstrap Warning color*/
	background: #f4772e;
}

.status-indicator.dark {
	/* Bootstrap Primery color*/
	background: #3c44b1;
}

.status-indicator::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	z-index: 1;
	filter: blur(8px);
	transition: box-shadow 0.3s ease, filter 0.3s ease;
}

.status-indicator.green::before {
	box-shadow: 0 0 5px 5px rgba(27, 201, 67, 0.5);
}

.status-indicator.red::before {
	box-shadow: 0 0 5px 5px rgba(220, 53, 69, 0.5);
}

.status-indicator.blue::before {
	box-shadow: 0 0 5px 5px rgba(65, 145, 255, 0.5);
}

.status-indicator.grey::before {
	box-shadow: 0 0 5px 5px rgba(108, 117, 125, 0.5);
}

.status-indicator.orange::before {
	box-shadow: 0 0 5px 5px rgba(255, 174, 0, 0.5);
}

.status-indicator.dark::before {
	box-shadow: 0 0 5px 5px rgba(0, 74, 177, 0.5);
}
/* end CommonCaseStatusIndicator */

.context-menu {
	position: absolute;
	background-color: #fff;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	z-index: 1000;
	border-radius: 4px;
	padding: 8px;
	min-width: 150px;
}

.context-menu-button {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	background-color: transparent;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	padding: 5px 10px;
	color: #3b3e66;
	text-align: left;
	transition: background-color 0.3s ease-in-out;
	text-wrap: nowrap;
}

.context-menu-button-icon {
	margin-right: 8px;
}

.context-menu-button:disabled {
	cursor: not-allowed;
	color: #ccc;
}

.context-menu-button:not(:disabled):hover {
	background-color: #F8F9FE;
}

.draggable-modal {
	min-width: 800px;
	box-sizing: border-box;
}

.draggable-modal__body {
	overflow: hidden;
	height: 750px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.draggable-modal__container {
	display: flex;
	height: calc(100% - 41px);
	box-sizing: border-box;
}

.modal-section {
	flex: 0 0 45%;
	border: 1px solid #EBEBEB;
	border-radius: 0.29rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;
}

.modal-section__header {
	border-bottom: 1px solid #EBEBEB;
}

.modal-section__header .padding-12 {
	padding: 12px;
}

.modal-section__list {
	flex: 1;
	height: 100%;
	overflow-y: auto;
}

.modal-section__list-item {
	display: flex;
	padding: 12px;
	border-bottom: 1px solid #EBEBEB;
}

.modal-actions {
	flex: 0 0 10%;
	display: flex;
	gap: 10px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0 10px;
}

.modal-action-button {
	width: fit-content;
	padding: 8px 16px;
	cursor: pointer;
	border: 1px solid #EBEBEB;
	box-shadow: 0px 4px 8px 0px #0000000F;
	border-radius: 2px;
}

.modal-selected {
	flex: 0 0 45%;
	border: 1px solid #EBEBEB;
	border-radius: 0.29rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

/* Dashboard Management */
.dashboard-mgmt {
	max-height: 89vh;
}

.dashboard-mgmt .crt-group-btn {
	font-size: 14px;
	border: 1px solid #3B3E66;
	border-radius: 8px;
	padding: 4px 16px;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.dashboard-mgmt .crt-group-btn:hover {
	background-color: #676EF7 !important;
	color: #fff;
}

.dashboard-mgmt-draggable-copy-modal {
	min-width: 500px;
	box-sizing: border-box;
}

.dashboard-mgmt-draggable-copy-modal__body {
	overflow: hidden;
	height: 600px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.dashboard-mgmt-draggable-modal__container {
	height: calc(100% - 41px);
	box-sizing: border-box;
	border: 1px solid #EBEBEB;
	border-radius: 4px;
	overflow: hidden;
}

.dashboard-mgmt-draggable-modal__container__scroll_area {
	height: calc(100% - 100px);
	overflow-y: auto;
}

.dashboard-mgmt-draggable-modal__dashboard-item {
	display: flex;
	padding: 12px 8px;
	border-bottom: 1px solid #EBEBEB;
}

.dashboard-mgmt-draggable-link-modal__body {
	overflow: hidden;
	height: fit-content;
	box-sizing: border-box;
}

.dashboard-mgmt .dashboard-container {
	height: 100%;
	border: 1px solid #D5D5DC;
	display: flex;
	flex-direction: column;
}

.dashboard-mgmt .customer-container {
	border: 1px solid #D5D5DC;
}

.dashboard-mgmt .border-bottom {
	border-bottom: 1px solid #D5D5DC;
}

.dashboard-mgmt .padding-round {
	padding: 20px 16px;
}

.dashboard-mgmt .btn-container {
	display: flex;
	gap: 8px;
}

.dashboard-mgmt .shared-mark {
	color: #6DD478;
	font-size: 14px;
}

.dashboard-mgmt .placeholder-title {
	color: #3B3E66;
	font-size: 18px;
}

.dashboard-mgmt .placeholder-subtitle {
	color: #676C6E;
	font-weight: 400;
}

.dashboard-mgmt .group-wrapper {
	border-radius: 0 !important;
	box-shadow: none;
}

.dshb-mgmt-accordion-container {
	max-height: calc(100% - 143px);
	flex: 0 0 calc(100% - 143px);
}

.dshb-mgmt-draggable-modal__container {
	display: flex;
	height: calc(100% - 145px);
	box-sizing: border-box;
}

.reportNameCells-popover {
	max-width: none;
	width: fit-content;
}

/* Multi Select shared component */
.multi-select-group-option {
	cursor: pointer;
	font-weight: bold;
	padding: 5px 10px;
	background-color: #f4f5fd;
	display: flex;
	align-items: center;
}

/* Case-File statuses component */
.case-file-st-types-container {
	border-top: 1px solid rgba(7, 9, 25, 0.125);
	border-bottom: 1px solid rgba(7, 9, 25, 0.125);
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 2;
}

.case-file-st-types-header {
	text-transform: uppercase;
	color: #bdbdc0;
	font-weight: 600;
}

.case-file-st-mb-last> :last-child {
	margin-bottom: 8px;
}

.case-file-st-category-icon {
	color: #676EF7;
	margin-left: 7px;
}

.case-file-st-table-icon {
	color: #676EF7;
	margin-right: 7px;
}

.case-file-st-simple-bar {
	height: calc(100% - 90px);
	overflow-y: auto;
	overflow-x: hidden;
}

.border-r {
	border-right: 1px solid rgba(122, 123, 151, 0.3);
}

.case-file-action-container {
	gap: 4px;
	justify-content: end;
}

.case-file-action-btn {
	padding: 5px 10px;
}

.case-file-action-btn:last-child {
	padding-right: 0 !important;
}

.z-index-1 {
	z-index: 1;
}

.artifacts-page .platform-card {
	border-radius: 18px;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.artifacts-page .platform-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.08) !important;
}

.artifacts-page .platform-icon svg {
	width: 64px;
	height: 64px;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;CACV,YAAY;CACZ,uBAAuB;CACvB;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX;AACD;;AAEA;CACC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,oBAAoB;AACrB;;AAEA,kCAAkC;AAClC;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,oCAAoC;CACpC,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,wCAAwC;CACxC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,oCAAoC;CACpC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,MAAM;CACN,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,8DAA8D;CAC9D,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B;AACD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,qBAAqB;CACrB,oBAAoB;CACpB,uBAAuB;CACvB,WAAW;CACX,uBAAuB;CACvB,qCAAqC;CACrC,gBAAgB;CAChB,oCAAoC;AACrC;;;AAGA;CACC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,qCAAqC;AACtC;;AAEA,oCAAoC;AACpC;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,aAAa;CACb,YAAY;CACZ,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,WAAW;CACX,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,gCAAgC;AACjC;;AAEA,uBAAuB;AACvB;CACC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,0CAA0C;CAC1C,eAAe;AAChB;;AAEA;CACC,gDAAgD;CAChD,UAAU;CACV,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,+CAA+C;CAC/C,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,8CAA8C;CAC9C,iDAAiD;CACjD,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,WAAW;CACX,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,sBAAsB;CACtB,aAAa;CACb,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,8CAA8C;CAC9C,kBAAkB;CAClB,aAAa;CACb,SAAS;AACV;;AAEA;CACC,YAAY;AACb;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,UAAU;AACX;;AAEA,KAAK;;AAEL,qBAAqB;AACrB;CACC,uBAAuB;CACvB,oBAAoB;AACrB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;CACpC,WAAW;AACZ;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,QAAQ;CACR,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,QAAQ;CACR,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;CAC/B,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA,8BAA8B;AAC9B;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,6BAA6B;AAC9B;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,iBAAiB;CACjB,kDAAkD;AACnD;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,6CAA6C;AAC9C;AACA,kCAAkC;;AAElC;CACC,kBAAkB;CAClB,sBAAsB;CACtB,wCAAwC;CACxC,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,WAAW;CACX,6BAA6B;CAC7B,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,6CAA6C;CAC7C,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,OAAO;CACP,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,aAAa;CACb,SAAS;CACT,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,yBAAyB;CACzB,qCAAqC;CACrC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA,yBAAyB;AACzB;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;CACpC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;CAC9B,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA,kCAAkC;AAClC;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;;AAEA,iCAAiC;AACjC;CACC,2CAA2C;CAC3C,8CAA8C;CAC9C,gBAAgB;CAChB,MAAM;CACN,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,QAAQ;CACR,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,qDAAqD;AACtD;;AAEA;CACC,2BAA2B;CAC3B,sDAAsD;AACvD;;AAEA;CACC,WAAW;CACX,YAAY;AACb","sourcesContent":[".section-group {\n\toverflow-y: auto;\n}\n\n.full-width-control {\n\twidth: 100%\n}\n\n.vcenter {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tfloat: none;\n}\n\nbody,\nhtml {\n\theight: 100%;\n}\n\nbody {\n\toverflow: hidden !important;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.switch-container {\n\theight: 750px;\n}\n\n.switch-container>li {\n\theight: 9%;\n}\n\n.switch-container>ul {\n\theight: 91%;\n}\n\n.list-wrapper {\n\theight: 550px;\n\tmargin-left: 15px;\n\tmargin-right: 15px;\n}\n\n.border-padding {\n\tmargin-left: 15px;\n\tmargin-right: 15px;\n}\n\n.list-wrapper>.list-container {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.vertical-center {\n\tmargin-bottom: auto;\n\tmargin-top: auto;\n}\n\n.spinner-center {\n\twidth: 4rem !important;\n\theight: 4rem !important;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tz-index: 6;\n\tmargin: -2rem 0 0 -2rem;\n}\n\n.spinner-wrapper {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 5;\n\topacity: 0.5;\n\tmargin: -2rem 0 0 -2rem;\n\tbackground-color: #efeeef\n}\n\n.modal-dialog>.modal-content {\n\toverflow: auto;\n\tresize: horizontal;\n}\n\n.move-cursor {\n\tcursor: move;\n}\n\n.no-cursor {\n\tcursor: auto;\n}\n\n.dropdown-scrollable {\n\theight: 155px;\n\tmin-width: 100%;\n\toverflow: auto;\n}\n\n.dropdown-no-scroll {\n\tmin-width: 100%;\n\toverflow: auto;\n}\n\n.truncated-line {\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twidth: 160px;\n\twhite-space: nowrap;\n}\n\n.label-default {\n\tfont-size: 1em !important;\n}\n\n.colorpicker-cover {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n}\n\n.colorpicker-popover {\n\tposition: absolute;\n\tz-index: 2;\n}\n\n.hue-wrapper {\n\theight: 12px;\n\tposition: relative;\n}\n\n.color-item-wrapper {\n\tbox-sizing: border-box;\n\twidth: 10%;\n\tpadding-right: 1px;\n\tfloat: left;\n}\n\n.color-item {\n\theight: 12px;\n\tcursor: pointer;\n}\n\n.color-item-active {\n\ttransform: scaleY(1.8);\n\tborder-radius: 3.6px/2px;\n}\n\n.color-item-pointer {\n\theight: 16px;\n\twidth: 16px;\n\tcursor: pointer;\n\tbox-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2)\n}\n\n.legend-box {\n\theight: 16px;\n\twidth: 16px;\n\tbox-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2)\n}\n\n.color-pointer-active {\n\ttransform: scale(1.4);\n\tborder-radius: 3.6px/2px;\n}\n\n.map-tooltip {\n\tpadding: 10px;\n\tbackground-color: black;\n\tcolor: white;\n\tposition: absolute;\n\tz-index: 1;\n\tpointer-events: none;\n}\n\n/* Override styles from Site.css */\n.sticky-head {\n\tbackground: white;\n\tfont-size: 1.0em\n}\n\n.table-scrollable {\n\t/*overflow: auto;*/\n\theight: 550px;\n}\n\n.table-cell-modified {\n\tbackground-color: #fcd9c4 !important;\n\tfont-weight: bold;\n}\n\n.container-height {\n\theight: 89vh;\n}\n\n.container-height-sm {\n\theight: 80vh;\n}\n\n.map-legend {\n\tpadding: 10px 10px 10px 3px;\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\tline-height: 18px;\n\tmargin-bottom: 40px;\n}\n\n.map-overlay {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tbackground: rgba(255, 255, 255, 0.8);\n\tmargin-right: 20px;\n\toverflow: auto;\n\tborder-radius: 3px;\n}\n\n.dropdown-top {\n\tz-index: 9999 !important;\n}\n\n.cursor-pointer {\n\tcursor: pointer;\n}\n\n.reporting-container-padding {\n\tpadding-left: 0 !important;\n}\n\n.no-margin {\n\tmargin: 0 !important;\n}\n\n.sticky-bottom {\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\tbottom: 0;\n}\n\n.sticky-top {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 4;\n\tborder: 0px !important;\n}\n\n.simplebar-scrollbar::before {\n\tbackground-color: rgba(0, 0, 0, 0.1);\n\tborder-radius: 6px;\n\ttransition: background-color .2s linear, width .2s ease-in-out;\n\tposition: absolute;\n}\n\n.overflow-visible {\n\toverflow: visible !important;\n}\n\n.li-dark {\n\tcolor: #fff;\n\tbackground-color: #3b3e66;\n}\n\n.pagination-wrapper {\n\tposition: absolute;\n\ttransform: translateX(-50%);\n\tleft: 50%\n}\n\n.dropdown-menu-sm {\n\tmin-width: 6rem;\n}\n\n.pe-none {\n\tpointer-events: none\n}\n\n.w-5 {\n\twidth: 5%;\n}\n\n.ra-item {\n\tpadding: 12px;\n}\n\n.ra-item.active,\n.ra-item:hover {\n\tbackground-color: #f4f5fc;\n}\n\n.dropdown-full-width>.truncated-line {\n\twidth: 100%;\n}\n\n.dropdown-with-icon>button::before {\n\tposition: relative;\n\ttop: 2px;\n\tright: 4px;\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: \"\";\n\tborder-top: 0.3em solid;\n\tborder-right: 0.3em solid transparent;\n\tborder-bottom: 0;\n\tborder-left: 0.3em solid transparent;\n}\n\n\n.lable-as-NavLink {\n\tcolor: #7a7b97;\n\tdisplay: flex;\n\tpadding: 8px 16px;\n\tmargin: 1px 0;\n\tborder-radius: 0.29rem;\n\tcursor: pointer;\n}\n\n.lable-as-NavLink:hover {\n\tbackground: rgba(122, 123, 151, 0.05);\n}\n\n/* Dashboard Mgmt tree view styles */\n.nested {\n\tposition: relative;\n}\n\n.nested::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: -12px;\n\tleft: 5px;\n\twidth: 1.5rem;\n\theight: 100%;\n\tborder-left: 1px solid #D7D7DF;\n}\n\n.nested::after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: -12px;\n\tleft: 5px;\n\twidth: 10px;\n\theight: 100%;\n\tborder-bottom: 1px solid #D7D7DF;\n}\n\n.nested span {\n\tposition: relative;\n}\n\n.nested span::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: -5px;\n\tleft: -11px;\n\twidth: 10px;\n\theight: 16px;\n\tborder-bottom: 1px solid #D7D7DF;\n}\n\n/* StaticReport page. */\n.static-reports-wrapper .nav-justified .nav-item {\n\tflex-grow: 0 !important;\n\tmin-width: 150px !important;\n}\n\n.static-reports-wrapper .container-height .tab-pane {\n\theight: calc(100% - 50px);\n}\n\n.cases-block .card {\n\tbox-shadow: none !important;\n\tborder: none !important;\n\tborder-radius: 0 !important;\n}\n\n.cases-block .card .card-header {\n\tborder-radius: 0 !important;\n}\n\n.cases-block .card-header {\n\tborder-radius: 0 !important;\n}\n\n.accordion-chevron {\n\ttransition: transform 0.3s ease-in-out;\n}\n\n.disabled-action-item {\n\tpointer-events: none;\n\topacity: 0.6;\n}\n\n.static-reports-editor-tab-container {\n\tborder: 1px solid rgba(122, 123, 151, 0.3);\n\tmax-width: 100%;\n}\n\n.static-reports-editor-tab-accordion-container {\n\tborder-right: 1px solid rgba(122, 123, 151, 0.3);\n\tpadding: 0;\n\tmax-width: 300px;\n\tmin-width: 300px;\n}\n\n.static-reports-editor-tab-scenarios-container {\n\tposition: 'relative';\n\tborder-left: 1px solid rgba(122, 123, 151, 0.3);\n\tmax-width: 400px;\n\tmin-width: 400px;\n}\n\n.static-reports-editor-tab-img-container {\n\tborder-radius: 50%;\n\tbackground-color: #ededed;\n\twidth: 100px;\n\theight: 100px;\n}\n\n.static-reports-editor-tab-btn-group-container {\n\theight: 50px;\n\tborder-top: 1px solid rgba(122, 123, 151, 0.3);\n\tborder-bottom: 1px solid rgba(122, 123, 151, 0.3);\n\tposition: relative;\n}\n\n.static-reports-editor-tab-toggle-btn-container {\n\twidth: fit-content;\n\tposition: absolute;\n\tright: 0;\n\ttop: 1px;\n\tz-index: 99;\n\tborder: 1px solid #D7D7DF;\n}\n\n.static-reports-toggle-result-btn-container {\n\twidth: fit-content;\n\tposition: absolute;\n\tright: 50%;\n\tbottom: 0;\n\tz-index: 99;\n\tborder: 1px solid #D7D7DF;\n\tborder-bottom: 0;\n}\n\n.static-reports-border-bottom {\n\tborder-bottom: 1px solid rgba(122, 123, 151, 0.3);\n}\n\n.static-reports-border-top {\n\tborder-top: 1px solid rgba(122, 123, 151, 0.3);\n}\n\n.static-reports-edit-modal-warning {\n\tdisplay: block;\n\tmin-height: 42px;\n\tmargin-top: 7px;\n}\n\n.static-reports-edit-modal-editor-wrapper {\n\tresize: vertical;\n\toverflow: hidden;\n\tmin-height: 200px;\n\tmax-height: 500px;\n\tborder: 1px solid #d1d2db;\n\tborder-radius: 0.29rem;\n}\n\n.saved-reports-tree-view-container {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\theight: calc(100% - 100px);\n}\n\n.static-reports-history-sidebar {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: 300px;\n\theight: 100%;\n\tbackground-color: #fff;\n\tz-index: 1000;\n\tborder: 1px solid #D7D7DF;\n\tbox-shadow: -7px 0px 7px 0px #00000012;\n}\n\n.static-reports-history-sidebar-header {\n\tborder-bottom: 1px solid #D7D7DF;\n\tbackground-color: #f4f5fd;\n}\n\n.static-reports-history-sidebar-scenario {\n\tborder-bottom: 1px solid rgba(7, 9, 25, 0.125);\n\tpadding: 10px 16px;\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.static-reports-history-sidebar-scenario b {\n\twidth: 210px;\n}\n\n/* Task 3589 on-hold */\n.static-reports-container-csv-file {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: fit-content;\n\tpadding: 16px 40px;\n\tborder: 1px dashed gray;\n\tborder-radius: 10px;\n}\n\n.static-reports-container-delete-btn {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 8px;\n\tcursor: pointer;\n\ttransition: color 0.3s ease;\n}\n\n.static-reports-container-delete-btn:hover {\n\tcolor: red;\n}\n\n/*  */\n\n/* Dashboard Viewer */\n.dashboard-viewer .cases-block-viewer .card {\n\theight: 100% !important;\n\tmargin: 0 !important;\n}\n\n.dashboard-viewer .cases-block-viewer .scrollbar-container {\n\theight: 100% !important;\n}\n\n.dashboard-viewer .crt-group-btn {\n\tfont-size: 14px;\n\tborder: 1px solid #3B3E66;\n\tborder-radius: 8px;\n\tpadding: 4px 8px;\n\tcursor: pointer;\n\ttransition: all 0.3s ease-in-out;\n}\n\n.dashboard-viewer .crt-group-btn:hover {\n\tbackground-color: #676EF7 !important;\n\tcolor: #fff;\n}\n\n.dashboard-viewer .border-light {\n\tborder: 1px solid #D7D7DF !important;\n}\n\n.dashboard-viewer .cases-sidebar {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 999;\n\tmax-width: 450px;\n\theight: calc(100% - 95px);\n\tmargin: 12px 0;\n}\n\n.dashboard-viewer .cases-sidebar .hide-arrow {\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tleft: -37px;\n}\n\n.dashboard-viewer .show-arrow {\n\ttop: 50%;\n\tright: 0;\n\ttransform: translateY(-50%);\n}\n\n.dashboard-viewer .show-arrow-viewer {\n\tborder-top-left-radius: 0.65rem;\n\tborder-bottom-right-radius: 0.65rem;\n}\n\n.dashboard-viewer .arrows {\n\tposition: absolute;\n\tz-index: 999;\n\tcursor: pointer;\n\tpadding: 8px;\n}\n\n.dashboard-viewer .group-wrapper {\n\tborder-radius: 0 !important;\n\tbox-shadow: none;\n}\n\n/* CommonCaseStatusIndicator */\n.status-indicator-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\twidth: 15px;\n}\n\n.status-indicator {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n\tfont-size: 1rem;\n\tfont-weight: bold;\n\tcolor: white;\n\tposition: relative;\n\tz-index: 2;\n\tborder: 5px solid transparent;\n}\n\n.status-indicator.green {\n\t/* Bootstrap Success color*/\n\tbackground: #1bc943;\n}\n\n.status-indicator.red {\n\t/* Bootstrap Danger color*/\n\tbackground: #dc3545;\n}\n\n.status-indicator.blue {\n\tbackground: #4191ff;\n}\n\n.status-indicator.grey {\n\t/* Bootstrap Secondary color*/\n\tbackground: #6c757d;\n}\n\n.status-indicator.orange {\n\t/* Bootstrap Warning color*/\n\tbackground: #f4772e;\n}\n\n.status-indicator.dark {\n\t/* Bootstrap Primery color*/\n\tbackground: #3c44b1;\n}\n\n.status-indicator::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 50%;\n\tz-index: 1;\n\tfilter: blur(8px);\n\ttransition: box-shadow 0.3s ease, filter 0.3s ease;\n}\n\n.status-indicator.green::before {\n\tbox-shadow: 0 0 5px 5px rgba(27, 201, 67, 0.5);\n}\n\n.status-indicator.red::before {\n\tbox-shadow: 0 0 5px 5px rgba(220, 53, 69, 0.5);\n}\n\n.status-indicator.blue::before {\n\tbox-shadow: 0 0 5px 5px rgba(65, 145, 255, 0.5);\n}\n\n.status-indicator.grey::before {\n\tbox-shadow: 0 0 5px 5px rgba(108, 117, 125, 0.5);\n}\n\n.status-indicator.orange::before {\n\tbox-shadow: 0 0 5px 5px rgba(255, 174, 0, 0.5);\n}\n\n.status-indicator.dark::before {\n\tbox-shadow: 0 0 5px 5px rgba(0, 74, 177, 0.5);\n}\n/* end CommonCaseStatusIndicator */\n\n.context-menu {\n\tposition: absolute;\n\tbackground-color: #fff;\n\tbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n\tz-index: 1000;\n\tborder-radius: 4px;\n\tpadding: 8px;\n\tmin-width: 150px;\n}\n\n.context-menu-button {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\tbackground-color: transparent;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tpadding: 5px 10px;\n\tcolor: #3b3e66;\n\ttext-align: left;\n\ttransition: background-color 0.3s ease-in-out;\n\ttext-wrap: nowrap;\n}\n\n.context-menu-button-icon {\n\tmargin-right: 8px;\n}\n\n.context-menu-button:disabled {\n\tcursor: not-allowed;\n\tcolor: #ccc;\n}\n\n.context-menu-button:not(:disabled):hover {\n\tbackground-color: #F8F9FE;\n}\n\n.draggable-modal {\n\tmin-width: 800px;\n\tbox-sizing: border-box;\n}\n\n.draggable-modal__body {\n\toverflow: hidden;\n\theight: 750px;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.draggable-modal__container {\n\tdisplay: flex;\n\theight: calc(100% - 41px);\n\tbox-sizing: border-box;\n}\n\n.modal-section {\n\tflex: 0 0 45%;\n\tborder: 1px solid #EBEBEB;\n\tborder-radius: 0.29rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tbox-sizing: border-box;\n}\n\n.modal-section__header {\n\tborder-bottom: 1px solid #EBEBEB;\n}\n\n.modal-section__header .padding-12 {\n\tpadding: 12px;\n}\n\n.modal-section__list {\n\tflex: 1;\n\theight: 100%;\n\toverflow-y: auto;\n}\n\n.modal-section__list-item {\n\tdisplay: flex;\n\tpadding: 12px;\n\tborder-bottom: 1px solid #EBEBEB;\n}\n\n.modal-actions {\n\tflex: 0 0 10%;\n\tdisplay: flex;\n\tgap: 10px;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0 10px;\n}\n\n.modal-action-button {\n\twidth: fit-content;\n\tpadding: 8px 16px;\n\tcursor: pointer;\n\tborder: 1px solid #EBEBEB;\n\tbox-shadow: 0px 4px 8px 0px #0000000F;\n\tborder-radius: 2px;\n}\n\n.modal-selected {\n\tflex: 0 0 45%;\n\tborder: 1px solid #EBEBEB;\n\tborder-radius: 0.29rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n/* Dashboard Management */\n.dashboard-mgmt {\n\tmax-height: 89vh;\n}\n\n.dashboard-mgmt .crt-group-btn {\n\tfont-size: 14px;\n\tborder: 1px solid #3B3E66;\n\tborder-radius: 8px;\n\tpadding: 4px 16px;\n\tcursor: pointer;\n\ttransition: all 0.3s ease-in-out;\n}\n\n.dashboard-mgmt .crt-group-btn:hover {\n\tbackground-color: #676EF7 !important;\n\tcolor: #fff;\n}\n\n.dashboard-mgmt-draggable-copy-modal {\n\tmin-width: 500px;\n\tbox-sizing: border-box;\n}\n\n.dashboard-mgmt-draggable-copy-modal__body {\n\toverflow: hidden;\n\theight: 600px;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.dashboard-mgmt-draggable-modal__container {\n\theight: calc(100% - 41px);\n\tbox-sizing: border-box;\n\tborder: 1px solid #EBEBEB;\n\tborder-radius: 4px;\n\toverflow: hidden;\n}\n\n.dashboard-mgmt-draggable-modal__container__scroll_area {\n\theight: calc(100% - 100px);\n\toverflow-y: auto;\n}\n\n.dashboard-mgmt-draggable-modal__dashboard-item {\n\tdisplay: flex;\n\tpadding: 12px 8px;\n\tborder-bottom: 1px solid #EBEBEB;\n}\n\n.dashboard-mgmt-draggable-link-modal__body {\n\toverflow: hidden;\n\theight: fit-content;\n\tbox-sizing: border-box;\n}\n\n.dashboard-mgmt .dashboard-container {\n\theight: 100%;\n\tborder: 1px solid #D5D5DC;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.dashboard-mgmt .customer-container {\n\tborder: 1px solid #D5D5DC;\n}\n\n.dashboard-mgmt .border-bottom {\n\tborder-bottom: 1px solid #D5D5DC;\n}\n\n.dashboard-mgmt .padding-round {\n\tpadding: 20px 16px;\n}\n\n.dashboard-mgmt .btn-container {\n\tdisplay: flex;\n\tgap: 8px;\n}\n\n.dashboard-mgmt .shared-mark {\n\tcolor: #6DD478;\n\tfont-size: 14px;\n}\n\n.dashboard-mgmt .placeholder-title {\n\tcolor: #3B3E66;\n\tfont-size: 18px;\n}\n\n.dashboard-mgmt .placeholder-subtitle {\n\tcolor: #676C6E;\n\tfont-weight: 400;\n}\n\n.dashboard-mgmt .group-wrapper {\n\tborder-radius: 0 !important;\n\tbox-shadow: none;\n}\n\n.dshb-mgmt-accordion-container {\n\tmax-height: calc(100% - 143px);\n\tflex: 0 0 calc(100% - 143px);\n}\n\n.dshb-mgmt-draggable-modal__container {\n\tdisplay: flex;\n\theight: calc(100% - 145px);\n\tbox-sizing: border-box;\n}\n\n.reportNameCells-popover {\n\tmax-width: none;\n\twidth: fit-content;\n}\n\n/* Multi Select shared component */\n.multi-select-group-option {\n\tcursor: pointer;\n\tfont-weight: bold;\n\tpadding: 5px 10px;\n\tbackground-color: #f4f5fd;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Case-File statuses component */\n.case-file-st-types-container {\n\tborder-top: 1px solid rgba(7, 9, 25, 0.125);\n\tborder-bottom: 1px solid rgba(7, 9, 25, 0.125);\n\tposition: sticky;\n\ttop: 0;\n\tbackground: #fff;\n\tz-index: 2;\n}\n\n.case-file-st-types-header {\n\ttext-transform: uppercase;\n\tcolor: #bdbdc0;\n\tfont-weight: 600;\n}\n\n.case-file-st-mb-last> :last-child {\n\tmargin-bottom: 8px;\n}\n\n.case-file-st-category-icon {\n\tcolor: #676EF7;\n\tmargin-left: 7px;\n}\n\n.case-file-st-table-icon {\n\tcolor: #676EF7;\n\tmargin-right: 7px;\n}\n\n.case-file-st-simple-bar {\n\theight: calc(100% - 90px);\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n\n.border-r {\n\tborder-right: 1px solid rgba(122, 123, 151, 0.3);\n}\n\n.case-file-action-container {\n\tgap: 4px;\n\tjustify-content: end;\n}\n\n.case-file-action-btn {\n\tpadding: 5px 10px;\n}\n\n.case-file-action-btn:last-child {\n\tpadding-right: 0 !important;\n}\n\n.z-index-1 {\n\tz-index: 1;\n}\n\n.artifacts-page .platform-card {\n\tborder-radius: 18px;\n\ttransition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.artifacts-page .platform-card:hover {\n\ttransform: translateY(-4px);\n\tbox-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.08) !important;\n}\n\n.artifacts-page .platform-icon svg {\n\twidth: 64px;\n\theight: 64px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
